//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_modelMaterial {\n\
vec3 diffuse;\n\
float alpha;\n\
vec3 specular;\n\
float roughness;\n\
vec3 normalEC;\n\
float occlusion;\n\
vec3 emissive;\n\
};\n\
";
